import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { createStructuredSelector } from 'reselect'

import { pathname } from 'store/entities/router/selectors'
import Footer from './Footer'

const mapStateToProps = createStructuredSelector({
  pathname,
})

const mapDispatchToProps = {
  onCancel: () => push('/'),
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
